import Map from './front-end/components/map'
import { detectIE } from './front-end/common/browser'
import Slider from './front-end/components/slider'
import Lightbox from './front-end/components/lightbox'
import ListComp from './front-end/components/list'
import Calendar from './front-end/components/calendar'
// import Hyphens from './front-end/components/hyphens'
// import Search from './front-end/components/search'
// import SponsorOverlays from './front-end/components/sponsor-overlays'
import AjaxLists from './front-end/components/ajax-lists'
import stickybits from 'stickybits'
import Stickyfill from 'stickyfilljs'

// Frontend Apps
import SearchApp from './front-end/apps/search'

import { find, exists, addClass } from './front-end/common/elements'

window.$ = window.$ || window.jQuery

const App = () => {
  let isIE = false
  const ready = (fn) => {
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn)
  }

  const MapMulti = (el) => {
    const map = new Map()

    map.createMap(el, null, JSON.parse(el.getAttribute('data-map-pins')))
  }

  const onDocReady = () => {
    const ie = detectIE()
    if (ie > 0 && ie < 12) {
      isIE = true
      addClass(find('html')[0], 'wwp3-is-IE')
    }

    if (exists('.wwp3-js-map')) {
      Map()
    }

    if (exists('.wwp3-js-slider')) {
      Slider()
    }

    if (exists('.wwp3-js-lightbox')) {
      Lightbox()
    }

    // if (exists('.wwp3-hyphens')) {
    //   Hyphens()
    // }

    // if (exists('.wwp3-js-list')) {
    //   ListComp()
    // }

    // if (exists('.wwp3-js-search')) {
    //   Search()
    // }

    if (exists('#wwp3-calendar')) {
      Calendar()
    }

    // if (exists('.wwp3-js-open-overlay')) {
    //   SponsorOverlays()
    // }

    if (exists('#wwp3-search')) {
      SearchApp()
    }

    if (exists('.wwp3-ajax-list')) {
      AjaxLists()
    }

    if (!isIE) {
      stickybits('.wwp3-sponsor__aside-container', {
        useStickyClasses: true,
      })
    }

    const mapsMulti = find('.wwp3-js-map-multi')

    for (let i = 0; i < mapsMulti.length; i++) new MapMulti(mapsMulti[i])
  }

  const init = () => {
    ready(onDocReady)
  }

  init()
}

App()



// WEBPACK FOOTER //
// src/assets/js/index.js